import { css } from "@emotion/react";

export const addStyles = ({ theme }) => css`
  margin: 0 auto;
  height: max-content;
  padding: 20px;

  @media (min-width: ${theme.screenSizes.mdMax}) {
    padding: 52px;
  }
`;
